<table class="table table-bordered table-hover">
  <thead class="table-dark">
    <tr>
      <th>ID</th>
      <th>Chore</th>
      <th>Client</th>
      <th>Eligible Reviewers</th>
      <th>Status</th>
      <th class="text-end">Count</th>
      <th class="text-end">Warning</th>
      <th class="text-end">Failed</th>
      <th class="text-end">Completed</th>
      <th>Life Cycle</th>
      <th class="text-center">&nbsp;</th>
    </tr>
  </thead>
  @if (clientChores.length > 0) {
    <tbody>
      @for (clientChore of clientChores; track clientChore; let i = $index) {
        <tr>
          <td>
            {{ clientChore.id }}
          </td>
          <td>
            <div><strong>{{ clientChore.displayName }}</strong></div>
            <app-simple-expandable-area maxHeight="3em">
              @if (clientChore.notes) {
                <div>
                  <ul>
                    <li class="phi">
                      <span class="param-name">Notes: </span>
                      {{ clientChore.notes }}
                    </li>
                  </ul>
                </div>
              }
              @if (clientChore.params['showStatusesInList'] !== false) {
                @if (clientChore.params['normalizedStatusesAndReasons']) {
                  <div>
                    <ul>
                      @if (clientChore.notes) {
                        <li>
                          <span class="param-name">Statuses: </span>
                        </li>
                      }
                      @for (statusAndReasons of clientChore.params['normalizedStatusesAndReasons'] | captureStatusesAndReasons; track statusAndReasons) {
                        <li>
                          {{ statusAndReasons }}
                        </li>
                      }
                    </ul>
                  </div>
                }
              }
            </app-simple-expandable-area>
          </td>
          <td>
            {{ clientChore.clientName | blankValueDash }}
          </td>
          <td>
            @if (clientChore.reviewableBy.length) {
              @for (user of clientChore.reviewableBy; track user; let last = $last) {
                {{user.fullName}}
                @if (!last) {
                  <br>
                  }
                }
              } @else {
                --
              }
            </td>
            <td>
              <app-client-chore-status
                [clientChore]="clientChore" />
              @if (clientChore.ended) {
                <app-client-chore-review
                  [reviewed]="clientChore.reviewed"
                  (reviewedChanged)="onReviewChange($event, clientChore)" />
              }
            </td>
            <td class="text-end">
              {{ clientChore.rows || 0 | number }}
            </td>
            <td class="text-end">
              {{ clientChore.counts?.warned || 0 | number }}
            </td>
            <td class="text-end">
              {{ clientChore.counts?.failed || 0 | number }}
            </td>
            <td class="text-end">
              {{ clientChore.counts?.completed || 0 | number }}
            </td>
            <td class="text-nowrap">
              <app-client-chore-lifecycle
                [clientChore]="clientChore" />
            </td>
            <td>
              @if (clientChore.fileExpirableDownloadPath) {
                <a
                  class="nav-link"
                  href="#"
                  (click)="onDownloadClick($event, clientChore.fileExpirableDownloadPath)">
                  INPUT
                </a>
              }
              @if (clientChore.reportExpirableDownloadPath) {
                <a
                  class="nav-link"
                  href="#"
                  (click)="onDownloadClick($event, clientChore.reportExpirableDownloadPath)">
                  REPORT
                </a>
              }
              @if (canManageChores && clientChore.status === 'processing' && clientChore.userFailable) {
                <a
                  class="nav-link"
                  href="#"
                  (click)="onFailClick($event, clientChore.id)">
                  FAIL
                </a>
              }
              @if (canManageChores && clientChore.inactive) {
                <a
                  class="nav-link"
                  href="#"
                  (click)="onRestartClick($event, clientChore.id)">
                  RESTART
                </a>
              }
            </td>
          </tr>
        }
      </tbody>
    } @else {
      <tbody>
        <tr>
          <td colspan="99">There are no client chores.</td>
        </tr>
      </tbody>
    }
  </table>
